"use client";

import posthog from "posthog-js";
import { PostHogProvider as PHProvider } from "posthog-js/react";
import { config } from "@/lib/config";

const POSTHOG_KEY = config.POSTHOG_KEY;
const POSTHOG_HOST = config.POSTHOG_HOST;

// Init at module scope so posthog is ready before any child useEffect runs
// (PostHogIdentify reads auth state and calls posthog.identify on mount).
if (typeof window !== "undefined" && POSTHOG_KEY && !(posthog as unknown as { __loaded?: boolean }).__loaded) {
  posthog.init(POSTHOG_KEY, {
    api_host: POSTHOG_HOST,
    capture_pageview: true,
    capture_pageleave: true,
    // $web_vitals is redundant here: Sentry (instrumentation-client.ts, 100%
    // client tracing) captures LCP/CLS/FCP/INP/TTFB. Disabled to cut PostHog
    // event spend (LIS-562 follow-up); explicit false overrides the
    // project-level remote config toggle.
    capture_performance: { web_vitals: false },
  });
}

export default function PostHogProvider({ children }: { children: React.ReactNode }) {
  if (!POSTHOG_KEY) {
    return <>{children}</>;
  }

  return <PHProvider client={posthog}>{children}</PHProvider>;
}
